module.exports = __webpack_public_path__ + "img/1.c387b070.jpg";